export const downloadFileFromUrl = (fileUrl: string, fileName: string = 'download'): void => {
  const a = document.createElement('a');
  a.download = fileName;
  a.href = fileUrl;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
